import { render, staticRenderFns } from "./CruiseInquiries.vue?vue&type=template&id=24fca07b&"
import script from "./CruiseInquiries.vue?vue&type=script&lang=js&"
export * from "./CruiseInquiries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports